import { FC } from 'react';

import { useIssueTypeQuery } from '@/api/getters';
import ComboBox from '@/components/ui/ComboBox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const ISSUE_TYPE_NAME = 'issue_type';

interface Props {
  name?: string;
  disabled?: boolean;
}

export const SelectIssueType: FC<Props> = ({
  name = ISSUE_TYPE_NAME,
  disabled,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();
  const { data } = useIssueTypeQuery();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: i18n.t('Uzupełnij to pole, aby przejść dalej'),
      }}
      render={({ field, fieldState }) => {
        return (
          <FormItem>
            <FormLabel>{i18n.t('Wskaż rodzaj szkody')}</FormLabel>
            <FormControl>
              <ComboBox
                field={field}
                value={field.value}
                placeholder={'Wybierz'}
                success={!fieldState.error && field.value}
                disabled={disabled}
                options={
                  data ?? [
                    {
                      value: '1',
                      label: 'Zalanie',
                    },
                  ]
                }
                scrollAreaMaxHeightClassName="md:max-h-[200px]"
                data-testid={`${name}-select`}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
